import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59080bc8&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=59080bc8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59080bc8",
  null
  
)

export default component.exports